<template>
  <div id="app" :class="vueAppClasses">
    <!-- Router outlet -->
    <router-view @setAppClasses="setAppClasses" />
    <ChatBot v-if="isLoggedIn" />
  </div>

</template>
<script>
import themeConfig from '@/../themeConfig.js'
import jwt from "@/http/requests/auth/jwt/index.js"
import AuthService from "@/auth/authService.js"
import ChatBot from './components/ChatBot/ChatBot.vue';

export default {
  name: "App",

  data() {
    return {
      vueAppClasses: [],
      qOpen: false,
      qUrl: null,
      loggedIn: false
    }
  },
  components: {
    ChatBot
  },
  computed: {
    isLoggedIn() {
      return this.loggedIn
    }
  },

  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl'(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr")
    },
    '$route'() {
      this.updateAuthStatus()
    },

  },

  methods: {
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr)
    },

    handleWindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },

    handleScroll() {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    },

    updateAuthStatus() {
      this.loggedIn = AuthService.isAuthenticated()
    },

    toggleClassInBody(val) {
      document.body.classList.remove('dark', 'light')
      document.body.classList.add(val)
    },
  },

  async mounted() {
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)

    this.updateAuthStatus()

    AuthService.on("loginEvent", (evt) => {
      this.loggedIn = evt.loggedIn
    })
  },

  async created() {
    jwt.init()
    document.documentElement.setAttribute("dir", this.$vs.rtl ? "rtl" : "ltr")

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)

    try {
      await AuthService.renewTokens()
      this.updateAuthStatus()
    } catch (e) {
      console.error(e)
      this.loggedIn = false
    }
  },

  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>
